module.exports = require("js-md5");